import React from "react";
import "./Benefits.css";

const BenefitsHead = () => {
  return (
    <div className="benefitsHeadContainer">
      <h2>
        The Trusted Choice: Why People Rely on <span>Goodway Attestation</span>
      </h2>
    </div>
  );
};

export default BenefitsHead;
